module.exports = "/virtual-football-league/img/fast-choosen-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/fast-choosen-bck.png
// module id = 328
// module chunks = 4